import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';
import { SetupIntent, StripeError } from '@stripe/stripe-js';

type TRequestPayload = {
  confirmPayment: Promise<{ setupIntent: SetupIntent; error?: undefined } | { error: StripeError }>;
};

type TSuccessPayload = { setupIntent: SetupIntent };

export const confirmPaymentMethodRequest = (state: Draft<IPaymentState>, { type }: PayloadAction<TRequestPayload>) => {
  state.openRequests = [...state.openRequests, type];
  state.failedRequests = state.failedRequests.filter((actionType) => actionType !== 'payment/confirmPaymentMethodFailure');
  state.updatedAt = Date.now();
};

export const confirmPaymentMethodSuccess = (state: Draft<IPaymentState>, { payload }: PayloadAction<TSuccessPayload>) => {
  state.updatedAt = Date.now();
  state.openRequests = state.openRequests.filter((actionType) => actionType !== 'payment/confirmPaymentMethodRequest');
  state.setupIntent = payload.setupIntent;
};

export const confirmPaymentMethodFailure = (state: Draft<IPaymentState>, { type }: PayloadAction<{ error: unknown }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [...state.failedRequests, type];
  state.openRequests = state.openRequests.filter((actionType) => actionType !== 'payment/confirmPaymentMethodRequest');
};
